import styled from 'styled-components';

export const Container = styled.div`
  .profile-image {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    background-size: cover;
    background-color: #eaeaea;
    background-position: center;
    border-radius: 100px;
  }
`;

export const Table = styled.table`
  text-align: center;
  margin-bottom: 0;

  td,
  th {
    vertical-align: middle;
  }

  .btn-small {
    padding: 1px 7px;
    font-size: 12px;
    margin: 0 5px;
  }
`;

export const Paginate = styled.div`
.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  cursor: Pointer;
}
.active {
    background-color: #000;
    a {
      color: #fff;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/PendingPromoters/styles.js